export default __webpack_public_path__ + "static/demo_modal_bg-7bac4a857b117da7af158d316f248c87.png";